// Import styles and JavaScript
import './event-teaser.scss';
import BceEventTeaser from './event-teaser.js';

export default BceEventTeaser;